<template>
  <div>
    <div v-if="!editView" class="dashboard-selector">
      <div>
        <md-button
          class="md-icon-button md-list-action"
          @click="
            () =>
              $router.push({
                name: 'ViewIndex',
                params: {
                  localId: localId,
                },
              })
          "
        >
          <md-icon>arrow_back</md-icon>
          <md-tooltip md-direction="left"> Voltar</md-tooltip>
        </md-button>
      </div>

      <div>
        <md-field>
          <label for="movie">Dashboards</label>
          <md-select
            id="movie"
            v-model="currentView"
            name="movie"
            @md-selected="atualizaView"
          >
            <md-option v-for="view in views" :key="view.id" :value="view.id">
              {{ view.titulo }}
            </md-option>
          </md-select>
        </md-field>
      </div>
    </div>
    <div
      ref="reference"
      class="view-canvas"
      :class="{ 'no-select': editView }"
      :style="canvasMinHeight ? `min-height: ${canvasMinHeight}` : ''"
    >
      <div v-if="view">
        <div v-for="componente in view.componentes" :key="componente.id">
          <div
            :id="`componente-${componente.id}`"
            class="componente"
            :class="{ 'componente-pipe': isPipe(componente) }"
            :style="componenteWrapperStyle(componente)"
          >
            <div>
              <ViewComponenteShow
                :local-id="localId"
                :componente="componente"
                :componente-tipo="componente.tipo"
                :editable="editView"
                :selected="isSelected(componente) && isSingleSelection"
                @loaded="onComponenteLoaded"
                @pipe-change="(v) => onPipeChange(componente, v)"
                @pipe-bodymove="(d) => onPipeBodyMove(componente, d)"
              />
            </div>
          </div>
        </div>

        <moveable
          v-if="editView"
          ref="moveable"
          :target="[Object.keys(selectedTargets)]"
          class-name="moveable"
          :draggable="!(selectionContainsPipe && isSingleSelection)"
          :scalable="!selectionContainsPipe"
          :keep-ratio="keepRatio"
          :rotatable="false"
          :snappable="true"
          :snap-directions="{
            top: true,
            left: true,
            bottom: true,
            right: true,
          }"
          :vertical-guidelines="verticalGuidelines"
          :horizontal-guidelines="horizontalGuidelines"
          :element-guidelines="elementGuidelines"
          @dragStart="onDragStart"
          @drag="onDrag"
          @dragEnd="onDragEnd"
          @scale="onScale"
          @rotate="onRotate"
          @dragGroupStart="onDragGroupStart"
          @dragGroupEnd="onDragEnd"
          @dragGroup="onDragGroup"
          @scaleGroup="onScaleGroup"
          @resizeGroup="onResizeGroup"
          @rotateGroup="onRotateGroup"
        />
      </div>

      <div
        v-if="isSelecting && selectionBox"
        class="selection-box"
        :style="`left: ${selectionBox.left}px; top: ${selectionBox.top}px; width: ${selectionBox.width}px; height: ${selectionBox.height}px;`"
      />

      <!-- Botoes de acao: overlay fora do elemento escalado, posicionado na
           borda direita do componente selecionado (nao herdam o scale). -->
      <div
        v-if="editView && isSingleSelection && actionsPos && selectedComponente"
        class="component-actions"
        :style="`left: ${actionsPos.left + 8}px; top: ${actionsPos.top}px;`"
      >
        <md-button
          class="md-icon-button md-list-action"
          @click="() => (deleteComponenteId = selectedComponente.id)"
        >
          <md-icon>delete</md-icon>
        </md-button>

        <md-button
          class="md-icon-button md-list-action"
          @click.stop="() => openEditComponente(selectedComponente)"
        >
          <md-icon>edit</md-icon>
        </md-button>

        <md-button
          v-if="!isPipe(selectedComponente)"
          class="md-icon-button md-list-action"
          :disabled="isOriginalScale(selectedComponente)"
          @click="() => resetScale(selectedComponente)"
        >
          <md-icon>restart_alt</md-icon>
        </md-button>
      </div>
    </div>

    <ViewToolbar v-if="editView" @selected="(e) => toolbarSelected(e)" />

    <ViewPipeDrawer
      v-if="pipeDrawing"
      :view-id="viewId"
      :z="nextZIndex"
      :reference-el="referenceEl"
      @created="onPipeCreated"
      @cancel="pipeDrawing = false"
    />

    <!-- --slider-z-index acima do menu lateral (10000) para o form de edicao de
         componente ficar por cima do menu, que sobrepoe a area do slider. -->
    <SliderRight ref="slider" :style="{ '--slider-z-index': 10001 }">
      <ViewComponenteForm
        :key="editComponente"
        :view-id="viewId"
        :local-id="$route.params.localId"
        :componente="editComponente"
        :componente-tipo="editComponenteTipo"
        @close="closeEditComponente"
        @updated="onComponenteUpdated"
      />
    </SliderRight>

    <md-dialog-confirm
      :md-backdrop="true"
      :md-active="deveAbrirModalDeleteComponente"
      md-title="Tem certeza?"
      md-content="Deletar um componente é uma ação irreversível. Após concluída os dados do componente não poderão ser recuperados"
      md-confirm-text="deletar"
      md-cancel-text="cancelar"
      @md-clicked-outside="deleteComponenteId = null"
      @md-cancel="deleteComponenteId = null"
      @md-confirm="() => deletarComponente()"
    />
  </div>
</template>

<script>
import moment from 'moment'
import Moveable from 'vue-moveable'

import { EventBus, Topics, Types } from '@/event-bus'
import { ComponenteTipo } from '@/utils/componente'
import {
  registerChannelListener,
  removeChannelListener,
} from '@/utils/web-socket'

import SliderRight from '../../components/SliderLeft.vue'
import ViewComponenteForm from '../../components/view/ViewComponenteForm.vue'
import ViewComponenteShow from '../../components/view/ViewComponenteShow.vue'
import ViewPipeDrawer from '../../components/view/ViewPipeDrawer.vue'
import ViewToolbar from '../../components/view/ViewToolbar.vue'
import store from '../../store'
import http from '../../utils/http'

export default {
  name: 'ViewComponentes',
  components: {
    ViewComponenteShow,
    ViewComponenteForm,
    ViewPipeDrawer,
    SliderRight,
    ViewToolbar,
    Moveable,
  },
  props: {
    editView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedTargets: {},
      deleteComponenteId: null,
      view: null,
      viewId: null,
      componenteIds: {},
      localId: null,
      editComponente: null,
      editComponenteTipo: null,
      changedPositionComponentes: {},
      // Valores de cano editados (vertice criado/removido/movido) ainda nao
      // persistidos. So sao efetivados ao clicar em "Salvar Posicao", igual as
      // posicoes em changedPositionComponentes.
      changedPipeValues: {},
      // Id do ultimo componente aberto no form de edicao. Guardado porque o form
      // emite `close` (que zera editComponente) ANTES de `updated`, entao no
      // handler de updated ja nao teriamos a referencia do componente editado.
      lastEditedComponenteId: null,
      views: [],
      currentView: null,
      lastReload: new Date(),
      lastReloadTimer: null,
      viewListenerRef: null,
      pipeDrawing: false,
      referenceEl: null,
      isSelecting: false,
      selectionBox: null,
      selectStart: null,
      selectionBase: {},
      pointerStart: null,
      pointerShift: false,
      pointerMoved: false,
      keepRatio: false,
      actionsPos: null,
      // Altura minima do canvas calculada para preencher da sua borda superior
      // ate o fim da viewport (sem zonas mortas para o retangulo de selecao).
      canvasMinHeight: null,
      // Posicao do componente no inicio do arrasto individual. Origem da trava
      // de eixo no Shift. null fora do arrasto.
      dragStartPos: null,
      // Posicoes iniciais por id no arrasto de grupo (id -> {x, y}).
      dragStartPosMap: {},
      // Grades fixas de snap. Mantidas como referencias estaveis para nao
      // forcar o moveable a reprocessar as guias quando nada relevante muda.
      baseVerticalGuidelines: [],
      baseHorizontalGuidelines: [],
    }
  },
  computed: {
    deveAbrirModalDeleteComponente() {
      return this.deleteComponenteId !== null
    },
    nextZIndex() {
      const componentes = (this.view && this.view.componentes) || []
      if (componentes.length === 0) return 0
      return Math.max(...componentes.map((c) => c.z || 0)) + 1
    },
    // Botoes por componente (deletar/editar/resetar) so aparecem quando ha
    // exatamente um componente selecionado.
    isSingleSelection() {
      return Object.keys(this.selectedTargets).length === 1
    },
    // True quando a selecao inclui ao menos um cano. Usado para desligar a
    // escala do moveable (canos nao escalam) e, na selecao unica, desligar o
    // arrasto do moveable (o cano gerencia o proprio arrasto de corpo/vertice).
    selectionContainsPipe() {
      return Object.keys(this.selectedTargets).some((k) =>
        this.isPipe(this.componenteIds[k.slice('#componente-'.length)])
      )
    },
    // O unico componente selecionado (ou null).
    selectedComponente() {
      const keys = Object.keys(this.selectedTargets)
      if (keys.length !== 1) return null
      const id = keys[0].slice('#componente-'.length)
      return this.componenteIds[id] || null
    },
    // Grade fixa de snap. Identidade estavel (mesma referencia base) para nao
    // forcar o moveable a reprocessar as guias por frame. A posicao inicial do
    // componente NAO entra aqui: a trava de eixo no Shift e feita no onDrag,
    // sem exibir guideline da propria origem.
    verticalGuidelines() {
      return this.baseVerticalGuidelines
    },
    horizontalGuidelines() {
      return this.baseHorizontalGuidelines
    },
    // So recomputa quando view.componentes ou a selecao muda. Durante drag/scale
    // mutamos changedPositionComponentes (nao view), entao a identidade do array
    // fica estavel e o moveable nao remede os rects por frame. Os componentes
    // SELECIONADOS sao excluidos para o alvo nao fazer snap na propria posicao
    // inicial (a selecao acontece antes do arrasto, entao ja vale no gesto).
    elementGuidelines() {
      const componentes = (this.view && this.view.componentes) || []
      const selectedIds = new Set(
        Object.keys(this.selectedTargets).map((k) =>
          k.slice('#componente-'.length)
        )
      )
      return componentes
        .filter((e) => !this.isPipe(e))
        .filter((e) => !selectedIds.has(e.id))
        .map((e) => `#componente-${e.id}`)
    },
  },
  watch: {
    // Reposiciona os botoes de acao quando a selecao muda (apos o DOM atualizar).
    selectedTargets() {
      this.$nextTick(this.positionActions)
    },
  },
  async beforeMount() {
    this.baseVerticalGuidelines = this.generateSnapGuidelines(20, 50)
    this.baseHorizontalGuidelines = this.generateSnapGuidelines(20, 100)

    this.lastReload = new Date()

    this.viewId = this.$route.params.viewId
    this.localId = this.$route.params.localId

    this.currentView = this.viewId

    const response = await http.get(
      `view/v2/local/${this.$route.params.localId}`
    )

    this.views = response?.views || []

    await store.dispatch('setToolbarView', false)

    await this.loadView()

    this.lastReloadTimer = setInterval(async () => {
      const duration = moment.duration(moment().diff(moment(this.lastReload)))

      if (duration.asMinutes() < 30) {
        return
      }

      location.reload()
    }, 10_000)
    if (this.editView) return
    await this.beginListenView()
  },
  mounted() {
    this.referenceEl = this.$refs.reference
    // Marca o .md-app-content que hospeda esta view para escopar o override de
    // padding (ver CSS). Sem isto, a regra nao-scoped `padding: 0` vazaria para
    // as demais paginas do app. Removido em beforeDestroy.
    this.contentHostEl =
      this.$refs.reference?.closest('.md-app-content') || null
    if (this.contentHostEl) this.contentHostEl.classList.add('view-canvas-host')
    // Captura para resolver o clique/arrasto de selecao antes do moveable, e
    // alcancar o componente mesmo quando coberto pela alca do moveable.
    document.addEventListener('mousedown', this.onCanvasMouseDown, true)
    // Segurar Shift mantem a proporcao ao escalar pelos pontos de controle.
    document.addEventListener('keydown', this.onShiftChange)
    document.addEventListener('keyup', this.onShiftChange)
    // Ctrl+A / Cmd+A: seleciona todos os componentes.
    document.addEventListener('keydown', this.onSelectAllKey)
    // Faz o canvas preencher ate o fim da viewport (sem zonas mortas para a
    // selecao por retangulo).
    this.updateCanvasMinHeight()
    window.addEventListener('resize', this.updateCanvasMinHeight)
  },
  beforeDestroy() {
    if (this.contentHostEl) {
      this.contentHostEl.classList.remove('view-canvas-host')
      this.contentHostEl = null
    }
    document.removeEventListener('mousedown', this.onCanvasMouseDown, true)
    document.removeEventListener('mousemove', this.onCanvasMouseMove, true)
    document.removeEventListener('mouseup', this.onCanvasMouseUp, true)
    document.removeEventListener('keydown', this.onShiftChange)
    document.removeEventListener('keyup', this.onShiftChange)
    document.removeEventListener('keydown', this.onSelectAllKey)
    window.removeEventListener('resize', this.updateCanvasMinHeight)
    if (this.selectRaf) cancelAnimationFrame(this.selectRaf)
    clearInterval(this.lastReloadTimer)
    store.dispatch('setToolbarView', true)
    if (this.viewListenerRef === null) return
    removeChannelListener(
      'view_id:' + this.viewId,
      'update_value',
      this.viewListenerRef
    )
  },
  methods: {
    updateCanvasMinHeight() {
      const ref = this.$refs.reference
      if (!ref) return

      const scroller = ref.closest('.md-app-scroller')
      if (!scroller) {
        // Fallback: sem o scroller, mede ate o fim da viewport.
        const top = ref.getBoundingClientRect().top
        this.canvasMinHeight = `${Math.max(0, window.innerHeight - top)}px`
        return
      }

      // Preenche da borda superior do canvas ate o fundo da AREA ROLAVEL (nao
      // da janela), para o retangulo de selecao alcancar toda a area sem criar
      // overflow permanente. `window.innerHeight` estourava ~41px por causa dos
      // insets abaixo do canvas (padding-bottom/margin-bottom do .md-app-content
      // e bordas), que ficam DENTRO do scroller mas ABAIXO do canvas.
      const refRect = ref.getBoundingClientRect()
      const scrollerRect = scroller.getBoundingClientRect()
      const visibleBottom = scrollerRect.top + scroller.clientHeight

      // Insets em fluxo normal abaixo do canvas. Componentes sao absolutos e nao
      // esticam o .md-app-content, entao sua caixa reflete so o fluxo normal:
      // (fundo do content - fundo do canvas) = padding-bottom; + margin-bottom.
      let insetBelow = 0
      const content = ref.closest('.md-app-content')
      if (content) {
        const contentRect = content.getBoundingClientRect()
        insetBelow += Math.max(0, contentRect.bottom - refRect.bottom)
        insetBelow += parseFloat(getComputedStyle(content).marginBottom) || 0
      }

      const available = visibleBottom - refRect.top - insetBelow
      this.canvasMinHeight = `${Math.max(0, Math.floor(available))}px`
    },
    generateSnapGuidelines(n, sum) {
      return Array.from({ length: n }, (_, i) => i * sum)
    },
    isPipe(componente) {
      return componente && componente.tipo === ComponenteTipo.PipeView
    },
    // Escala original = 1x1 (sem escala aplicada). Usado para desabilitar o
    // botao de resetar escala quando nao ha o que resetar.
    isOriginalScale(componente) {
      return (
        !!componente &&
        (componente.scaleX || 1) === 1 &&
        (componente.scaleY || 1) === 1
      )
    },
    isSelected(componente) {
      return !!this.selectedTargets[`#componente-${componente.id}`]
    },
    // Posiciona o overlay de botoes na borda direita do componente selecionado,
    // medindo o retangulo real na tela (imune ao scale/transform do elemento).
    onComponenteLoaded() {
      // Conteudo assincrono (ex.: imagem) muda o tamanho do elemento apos o
      // render. Recalcula o rect do moveable para a alca acompanhar o novo
      // tamanho.
      this.$nextTick(() => {
        if (this.$refs.moveable && this.$refs.moveable.updateRect) {
          this.$refs.moveable.updateRect()
        }
        this.positionActions()
      })
    },
    positionActions() {
      const comp = this.selectedComponente
      const canvas = this.$refs.reference
      const el = comp && document.getElementById(`componente-${comp.id}`)
      if (!comp || !canvas || !el) {
        this.actionsPos = null
        return
      }
      const er = el.getBoundingClientRect()
      const cr = canvas.getBoundingClientRect()
      this.actionsPos = { left: er.right - cr.left, top: er.top - cr.top }
    },
    onSelectAllKey(e) {
      // So no modo edicao, e sem sequestrar o Ctrl+A quando o foco esta num
      // campo de texto (deixa o navegador selecionar o texto normalmente).
      if (!this.editView) return
      if ((e.key === 'a' || e.key === 'A') && (e.ctrlKey || e.metaKey)) {
        const el = e.target
        const tag = el && el.tagName
        const isTextField =
          tag === 'INPUT' || tag === 'TEXTAREA' || (el && el.isContentEditable)
        if (isTextField) return
        e.preventDefault()
        this.selectAll()
      }
    },
    selectAll() {
      if (!this.view || !this.view.componentes) return
      const next = {}
      this.view.componentes.forEach((componente) => {
        next[`#componente-${componente.id}`] = {
          id: `#componente-${componente.id}`,
        }
      })
      this.selectedTargets = next
      // Remede a alca do moveable e reposiciona os botoes contra o DOM ja
      // refletindo a nova selecao.
      this.$nextTick(() => {
        if (this.$refs.moveable && this.$refs.moveable.updateRect) {
          this.$refs.moveable.updateRect()
        }
        this.positionActions()
      })
    },
    selectTarget(id, event) {
      const key = `#componente-${id}`

      // Shift soma/alterna; clique simples seleciona somente este.
      if (event && event.shiftKey) {
        if (this.selectedTargets[key]) {
          delete this.selectedTargets[key]
        } else {
          this.selectedTargets[key] = { id: key }
        }
        this.selectedTargets = { ...this.selectedTargets }
        return
      }

      this.selectedTargets = { [key]: { id: key } }
    },
    onCanvasMouseDown(e) {
      // So no modo edicao e com botao esquerdo.
      if (!this.editView || e.button !== 0) return

      const ref = this.$refs.reference
      const t = e.target
      if (!ref) return
      // Fundo da lousa = a propria .view-canvas OU qualquer ancestral dela
      // (wrapper, .md-app-content, scroller, md-app). Com o canvas em position:
      // absolute (fora do fluxo), cliques no vazio da area rolada caem nesses
      // ancestrais; checar so content/scroller deixava zonas mortas que nao
      // desmarcavam. Overlays (menu, slider, dialogs) sao subarvores irmas: nao
      // contem o canvas, entao `t.contains(ref)` os exclui naturalmente.
      const onCanvasBackground = ref.contains(t) || t.contains(ref)
      if (!onCanvasBackground) return
      // Botoes (deletar/editar/reset) e demais controles: deixa o handler agir.
      if (t.closest('button')) return

      const onControlBox = !!t.closest('.moveable-control-box')
      const onComponent = !!t.closest('.componente')
      // A camada editavel do cano (hit-lines/handles) vive num SVG portado para o
      // body: clicar nela e clicar NO cano, nao no fundo. Sem isto, clicar na
      // linha de um cano selecionado iniciaria um retangulo de selecao (limpando
      // a selecao) em vez de permitir mover/desmarcar.
      const onPipeOverlay = !!t.closest('.pipe-overlay-portal')

      this.pointerStart = { x: e.clientX, y: e.clientY }
      this.pointerShift = e.shiftKey
      this.pointerMoved = false
      // Retangulo de selecao so quando comeca no "fundo" (nao em componente, nem
      // na alca do moveable, nem na camada editavel do cano).
      this.isSelecting = !onComponent && !onControlBox && !onPipeOverlay

      if (this.isSelecting) {
        e.preventDefault()
        // Snapshot da selecao: com Shift somamos a ela; sem Shift partimos do zero.
        this.selectionBase = e.shiftKey ? { ...this.selectedTargets } : {}
        this.selectStart = { x: e.clientX, y: e.clientY }
        this.selectionBox = {
          left: e.clientX,
          top: e.clientY,
          width: 0,
          height: 0,
        }
      }

      document.addEventListener('mousemove', this.onCanvasMouseMove, true)
      document.addEventListener('mouseup', this.onCanvasMouseUp, true)
    },
    onCanvasMouseMove(e) {
      if (
        Math.abs(e.clientX - this.pointerStart.x) > 3 ||
        Math.abs(e.clientY - this.pointerStart.y) > 3
      ) {
        this.pointerMoved = true
      }

      if (!this.isSelecting) return

      const { x, y } = this.selectStart
      // Throttle por frame: guarda apenas a caixa do evento (barato) e adia o
      // processamento pesado (intersecao + update reativo) para no maximo uma
      // vez por frame. mousemove dispara mais rapido que o repaint e cada update
      // de selectedTargets forca o moveable a recalcular os rects de todos os
      // alvos e das element-guidelines (reflow).
      this.pendingSelectBox = {
        left: Math.min(x, e.clientX),
        top: Math.min(y, e.clientY),
        width: Math.abs(e.clientX - x),
        height: Math.abs(e.clientY - y),
      }
      if (!this.selectRaf) {
        this.selectRaf = requestAnimationFrame(this.flushSelection)
      }
    },
    flushSelection() {
      // Aplica a ultima caixa pendente (coalesce). Idempotente: seguro chamar
      // tanto pelo rAF quanto manualmente ao soltar.
      if (this.selectRaf) {
        cancelAnimationFrame(this.selectRaf)
        this.selectRaf = null
      }
      const box = this.pendingSelectBox
      if (!box) return
      this.pendingSelectBox = null

      this.selectionBox = box

      // Atualiza a selecao ao vivo enquanto arrasta (apos o limiar de clique).
      if (box.width > 3 || box.height > 3) {
        const next = this.targetsIntersectingBox(box)
        // Evita reatribuir (e re-renderizar o moveable) quando a selecao nao
        // mudou desde o frame anterior.
        if (!this.sameSelection(next, this.selectedTargets)) {
          this.selectedTargets = next
        }
      }
    },
    sameSelection(a, b) {
      const ka = Object.keys(a)
      const kb = Object.keys(b)
      if (ka.length !== kb.length) return false
      return ka.every((k) => k in b)
    },
    onCanvasMouseUp(e) {
      document.removeEventListener('mousemove', this.onCanvasMouseMove, true)
      document.removeEventListener('mouseup', this.onCanvasMouseUp, true)

      // Conclui a selecao pendente ao soltar (antes de um eventual "Salvar
      // posicao"). Drag/scale ja persistem de forma sincrona em cada evento.
      this.flushSelection()

      // Apos um drag/scale (especialmente saindo de um snap), o estado interno do
      // moveable pode divergir da posicao real do elemento. Forca a alca a
      // remedir o retangulo a partir do DOM ja atualizado.
      if (
        !this.isSelecting &&
        this.$refs.moveable &&
        this.$refs.moveable.updateRect
      ) {
        this.$refs.moveable.updateRect()
      }

      if (this.isSelecting) {
        // Retangulo concluido (selecao ja aplicada ao vivo). Sem arrasto = clique
        // no fundo: limpa (a menos de Shift, que preserva a selecao atual).
        this.isSelecting = false
        this.selectionBox = null
        if (!this.pointerMoved && !this.pointerShift) {
          this.selectedTargets = {}
        }
        return
      }

      // Comecou sobre um componente ou sobre a alca do moveable.
      // Se houve arrasto, foi o moveable movendo/escalando: nao mexe na selecao.
      if (this.pointerMoved) return

      // Clique simples: descobre o componente sob o cursor (mesmo coberto pela
      // alca do moveable) e seleciona (clique simples) ou alterna (Shift).
      const id = this.componentIdAtPoint(e.clientX, e.clientY)
      if (id == null) return
      this.selectTarget(id, { shiftKey: this.pointerShift })
    },
    componentIdAtPoint(x, y) {
      const els = document.elementsFromPoint(x, y)
      for (const el of els) {
        const wrapper = el.closest && el.closest('.componente')
        if (wrapper && wrapper.id.startsWith('componente-')) {
          return wrapper.id.slice('componente-'.length)
        }
      }
      return null
    },
    targetsIntersectingBox(box) {
      // Intersecta a caixa com cada componente. Coordenadas em viewport
      // (clientX/Y e getBoundingClientRect), imunes a transform/scroll. Parte do
      // snapshot base (Shift soma) e alterna (toggle) quem cai dentro: ja
      // selecionado no base => desfaz a selecao; ainda nao selecionado =>
      // seleciona.
      const next = { ...this.selectionBase }
      this.view.componentes.forEach((componente) => {
        const el = document.getElementById(`componente-${componente.id}`)
        if (!el) return
        const r = el.getBoundingClientRect()
        const intersects =
          r.left < box.left + box.width &&
          r.right > box.left &&
          r.top < box.top + box.height &&
          r.bottom > box.top
        if (!intersects) return

        const key = `#componente-${componente.id}`
        if (this.selectionBase[key]) {
          delete next[key]
        } else {
          next[key] = { id: key }
        }
      })
      return next
    },
    async beginListenView() {
      this.viewListenerRef = await registerChannelListener(
        'view_id:' + this.viewId,
        'update_value',
        () => {
          this.loadView()
        }
      )
    },
    async atualizaView() {
      await this.$router.push({
        name: 'ViewComponentesShow',
        params: {
          localId: this.localId,
          viewId: this.currentView,
        },
      })
    },
    async loadView() {
      // v1 traz os tipos legados; v2 traz os tipos novos (canos, tabelas de
      // sensores virtuais) que o v1 filtra. As respostas sao complementares e
      // vem do mesmo backend, entao juntamos os componentes das duas.
      const [v1, v2] = await Promise.all([
        http.get(`view/${this.viewId}`),
        http.get(`view/v2/${this.viewId}`),
      ])

      // http.get retorna null em erro (ja exibe o toast). Tudo-ou-nada: se
      // qualquer um falhar, nao renderiza uma view parcial/enganosa (num SCADA,
      // sumir com canos/tabelas sem avisar e risco operacional). Preserva a view
      // atual; o usuario recarrega.
      if (!v1?.view || !v2?.view) return

      this.view = v1.view
      this.view.componentes = [
        ...(v1.view.componentes || []),
        ...(v2.view.componentes || []),
      ]

      // Reaplica posicoes movidas mas ainda nao salvas, para nao perde-las ao
      // recarregar a view (ex.: ao criar outro componente antes de "Salvar
      // posicao"). O componente so volta a origem depois de salvar/recarregar
      // a pagina.
      this.view.componentes.forEach((componente) => {
        const pending = this.changedPositionComponentes[componente.id]
        if (pending) {
          componente.x = pending.x
          componente.y = pending.y
          if (pending.z != null) componente.z = pending.z
          if (pending.scaleX != null) componente.scaleX = pending.scaleX
          if (pending.scaleY != null) componente.scaleY = pending.scaleY
        }
        // Reaplica edicoes de cano ainda nao salvas (vertices criados/removidos/
        // movidos) para nao perde-las ao recarregar a view antes de salvar.
        const pendingValue = this.changedPipeValues[componente.id]
        if (pendingValue) componente.value = pendingValue
      })

      this.componenteIds = this.view.componentes.reduce((acc, componente) => {
        acc[componente.id] = componente
        return acc
      }, {})

      // Reposiciona os botoes de acao e recalcula a altura do canvas apos o DOM
      // refletir a view recarregada. Remede tambem a alca do moveable: editar o
      // estilo (ex.: espessura do cano) muda a bbox do componente, e sem isso a
      // alca mantem o tamanho antigo ate uma nova selecao.
      this.$nextTick(() => {
        if (this.$refs.moveable && this.$refs.moveable.updateRect) {
          this.$refs.moveable.updateRect()
        }
        this.positionActions()
        this.updateCanvasMinHeight()
      })
    },
    toolbarSelected(e) {
      if (e === 'pipeDrawing') {
        this.pipeDrawing = true
        return
      }

      if (Object.values(ComponenteTipo).includes(e)) {
        this.editComponente = null
        this.editComponenteTipo = e

        this.$refs.slider.toogleTab()
      }

      if (e === 'saveDragPositions') {
        this.saveComponentes()
      }
    },
    async onPipeCreated() {
      this.pipeDrawing = false
      await this.loadView()
    },
    async onComponenteUpdated() {
      // O form de edicao ja persistiu o `value` completo via PUT (inclusive
      // edicoes de vertice que estavam mescladas em componente.value). O pendente
      // em changedPipeValues agora esta obsoleto: se mantido, o loadView o
      // reaplicaria por cima do valor recem-salvo e a alteracao (ex.: toggle de
      // "Cor plana") so refletiria ao recarregar a pagina.
      if (this.lastEditedComponenteId != null) {
        delete this.changedPipeValues[this.lastEditedComponenteId]
      }
      await this.loadView()
    },
    onPipeChange(componente, value) {
      // Normaliza os pontos para que o menor x/y seja 0, deslocando a posicao
      // (x/y) do componente pela mesma quantia. Sem isso a bbox do cano so
      // cresce para a direita/baixo: quando um vertice passa da origem, a borda
      // esquerda/superior da alca do moveable nao acompanha (a bbox usa apenas o
      // max dos pontos, ancorada em 0,0).
      const { value: normalized } = this.normalizePipeValue(componente, value)
      componente.value = normalized

      // Nao persiste agora: criar/remover/mover vertice so e efetivado ao clicar
      // em "Salvar Posicao". Acumula o valor (e a posicao, que a normalizacao
      // pode ter deslocado) para o cano nao "pular" ao recarregar a view.
      this.changedPipeValues[componente.id] = normalized
      this.changedPositionComponentes[componente.id] = {
        id: componente.id,
        x: componente.x,
        y: componente.y,
        z: componente.z,
        scaleX: componente.scaleX || 1,
        scaleY: componente.scaleY || 1,
      }

      // Edicao de vertice muda a bbox do cano; remede a alca do moveable.
      this.refreshMoveableRect()
    },
    // Desloca os pontos livres para que o menor x/y seja 0 e compensa em x/y do
    // componente (mesma posicao visual, bbox ancorada na origem). Retorna o
    // valor normalizado e se houve deslocamento.
    normalizePipeValue(componente, value) {
      const freePoints = (value.points || []).filter((p) => p.free)
      if (!freePoints.length) return { value, shifted: false }

      const minX = Math.min(...freePoints.map((p) => p.free.x))
      const minY = Math.min(...freePoints.map((p) => p.free.y))
      if (minX === 0 && minY === 0) return { value, shifted: false }

      const normalized = {
        ...value,
        points: value.points.map((p) =>
          p.free
            ? { free: { x: p.free.x - minX, y: p.free.y - minY } }
            : { ...p }
        ),
      }
      componente.x = Math.round((componente.x || 0) + minX)
      componente.y = Math.round((componente.y || 0) + minY)
      return { value: normalized, shifted: true }
    },
    onPipeBodyMove(componente, { dx, dy }) {
      // Espelha o onDrag dos demais componentes: atualiza a posicao localmente e
      // acumula em changedPositionComponentes. So persiste no "Salvar posicao".
      componente.x = Math.round((componente.x || 0) + dx)
      componente.y = Math.round((componente.y || 0) + dy)
      this.changedPositionComponentes[componente.id] = {
        id: componente.id,
        x: componente.x,
        y: componente.y,
        z: componente.z,
        scaleX: componente.scaleX || 1,
        scaleY: componente.scaleY || 1,
      }
      // O corpo do cano se moveu; a alca do moveable acompanha a nova posicao.
      this.refreshMoveableRect()
    },
    // Remede o retangulo da alca do moveable a partir do DOM ja atualizado e
    // reposiciona os botoes de acao.
    refreshMoveableRect() {
      this.$nextTick(() => {
        if (this.$refs.moveable && this.$refs.moveable.updateRect) {
          this.$refs.moveable.updateRect()
        }
        this.positionActions()
      })
    },
    closeEditComponente() {
      this.editComponente = null
      this.$refs.slider.toogleTab()
    },
    openEditComponente(componente) {
      this.editComponente = componente
      this.lastEditedComponenteId = componente.id
      this.editComponenteTipo = componente.tipo

      if (this.$refs.slider.isOpened()) {
        this.$refs.slider.toogleTab()
      }

      this.$refs.slider.toogleTab()
    },
    async deletarComponente() {
      const deletedId = this.deleteComponenteId
      const res = await http.delete(`view/componente`, deletedId)
      this.deleteComponenteId = null

      // http.delete retorna null em erro (ja exibe o toast). So atualiza o estado
      // local se de fato deletou — senao o componente reaparece no proximo load,
      // com a UI fingindo que foi removido.
      if (res == null) return

      this.view.componentes = this.view.componentes.filter(
        (c) => c.id !== deletedId
      )

      // Remove o alvo deletado da selecao para que a alca do moveable suma
      // imediatamente (o :target do moveable segue selectedTargets).
      const key = `#componente-${deletedId}`
      if (this.selectedTargets[key]) {
        const next = { ...this.selectedTargets }
        delete next[key]
        this.selectedTargets = next
      }

      this.$nextTick(() => {
        if (this.$refs.moveable && this.$refs.moveable.updateRect) {
          this.$refs.moveable.updateRect()
        }
        this.positionActions()
      })
    },
    async saveComponentes() {
      const changedPositions = Object.values(this.changedPositionComponentes)
      const changedPipes = Object.entries(this.changedPipeValues)

      // Nada pendente: evita PUT vazio e toast de "salvo" sem ter salvo nada.
      if (!changedPositions.length && !changedPipes.length) return

      // http.put retorna null em erro (nao lanca). Acumula o sucesso de cada
      // requisicao para so limpar os pendentes se TUDO persistiu.
      let ok = true

      // showNotification=false em cada PUT: em vez de um toast por requisicao,
      // emitimos um unico ao final. Os toasts de erro continuam (handlerError).
      if (changedPositions.length) {
        const res = await http.put(
          `view/componente/position`,
          {
            viewId: this.viewId,
            positions: changedPositions,
          },
          false
        )
        if (res == null) ok = false
      }

      // Persiste os valores de cano editados (vertices criados/removidos/movidos)
      // que tambem so sao efetivados aqui. Como sao componentes independentes,
      // os PUTs vao em paralelo.
      const pipeResults = await Promise.all(
        changedPipes.map(([id, value]) => {
          const comp = this.componenteIds[id]
          return http.put(
            `view/componente`,
            {
              id,
              z: comp ? comp.z : undefined,
              value,
            },
            false
          )
        })
      )
      if (pipeResults.some((res) => res == null)) ok = false

      // So limpa os pendentes se tudo persistiu; caso contrario preserva para o
      // usuario tentar de novo e para o loadView reaplicar o que nao foi salvo.
      if (ok) {
        this.changedPositionComponentes = {}
        this.changedPipeValues = {}
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.INFO,
          message: 'Posições salvas com sucesso',
        })
      }
    },
    componentTransform(componente) {
      const sx = componente.scaleX || 1
      const sy = componente.scaleY || 1
      return `transform: translate(${componente.x}px, ${componente.y}px) scale(${sx}, ${sy});`
    },
    // Estilo do wrapper .componente: transform + z-index. O z-index PRECISA estar
    // no .componente (position:absolute), pois z-index e ignorado em elementos
    // estaticos — antes ele estava numa div interna estatica e a "Ordem" nao
    // surtia efeito. Todos os componentes (canos inclusive) usam componente.z
    // ("Ordem"). O cano NAO sobe ao ser selecionado: so a camada editavel (alcas
    // /vertices) sobe, via portal proprio (z 9990) no ViewShowPipe/PipeOverlayPortal.
    componenteWrapperStyle(componente) {
      return `${this.componentTransform(componente)} z-index: ${
        componente.z || 0
      };`
    },
    onDragStart(event) {
      // Guarda a posicao inicial do componente: origem da trava de eixo quando
      // Shift esta pressionado durante o arrasto.
      const { target } = event
      const id = target.id.split('-')[1]
      const comp = this.componenteIds[id]
      this.dragStartPos = comp ? { x: comp.x, y: comp.y } : null
    },
    onDragGroupStart({ events }) {
      // Captura a posicao inicial de cada alvo do grupo para a trava de eixo.
      const map = {}
      events.forEach((ev) => {
        const id = ev.target.id.split('-')[1]
        const comp = this.componenteIds[id]
        if (comp) map[id] = { x: comp.x, y: comp.y }
      })
      this.dragStartPosMap = map
      this.dragStartPos = null
    },
    onDragEnd() {
      this.dragStartPos = null
      this.dragStartPosMap = {}
    },
    onDrag(event, lockAxis, startPos) {
      // Modelo do Syncou: aplica event.transform direto no elemento e persiste
      // apenas x/y (a escala vem do estado reativo via componentTransform).
      // lockAxis/startPos sao passados pelo arrasto de grupo (eixo unico para o
      // grupo todo); no arrasto individual sao derivados de dragStartPos.
      const { target } = event
      const id = target.id.split('-')[1]
      const comp = this.componenteIds[id]
      if (!comp) return

      let [x, y] = event.beforeTranslate

      // Arrasto individual: deriva a trava do delta real do mouse
      // (beforeTranslate vs posicao inicial), nao da posicao ja travada.
      if (lockAxis === undefined && this.keepRatio && this.dragStartPos) {
        const dx = x - this.dragStartPos.x
        const dy = y - this.dragStartPos.y
        lockAxis = Math.abs(dx) >= Math.abs(dy) ? 'y' : 'x'
        startPos = this.dragStartPos
      }

      // Shift: trava o movimento em um unico eixo, permitindo mover so na
      // horizontal ou so na vertical mesmo arrastando o mouse na diagonal.
      if (lockAxis && startPos) {
        if (lockAxis === 'y') {
          y = startPos.y
        } else {
          x = startPos.x
        }
        const sx = comp.scaleX || 1
        const sy = comp.scaleY || 1
        target.style.transform = `translate(${x}px, ${y}px) scale(${sx}, ${sy})`
      } else {
        target.style.transform = event.transform
      }

      comp.x = x
      comp.y = y

      this.changedPositionComponentes[id] = {
        id: id,
        x: Math.round(x),
        y: Math.round(y),
        z: comp.z,
        scaleX: comp.scaleX || 1,
        scaleY: comp.scaleY || 1,
      }

      this.positionActions()
    },
    resetScale(componente) {
      const id = componente.id
      componente.scaleX = 1
      componente.scaleY = 1

      this.changedPositionComponentes[id] = {
        id: id,
        x: Math.round(componente.x),
        y: Math.round(componente.y),
        z: componente.z,
        scaleX: 1,
        scaleY: 1,
      }

      // O re-render reaplica componentTransform (scale 1); depois remede a alca
      // do moveable e reposiciona os botoes na nova borda.
      this.$nextTick(() => {
        if (this.$refs.moveable && this.$refs.moveable.updateRect) {
          this.$refs.moveable.updateRect()
        }
        this.positionActions()
      })
    },
    onScale(event) {
      // Modelo do Syncou: escala a partir do CENTRO. event.transform mantem o
      // translate original e so troca o scale, entao x/y nao mudam. event.scale
      // ja vem cumulativo (o moveable semeia o startValue a partir do scale()
      // existente no elemento), entao acumula corretamente entre gestos.
      const { target, transform, scale } = event
      const id = target.id.split('-')[1]
      const comp = this.componenteIds[id]
      if (!comp) return

      target.style.transform = transform

      const [scaleX, scaleY] = scale
      comp.scaleX = scaleX
      comp.scaleY = scaleY

      this.changedPositionComponentes[id] = {
        id: id,
        x: Math.round(comp.x),
        y: Math.round(comp.y),
        z: comp.z,
        scaleX,
        scaleY,
      }

      this.positionActions()
    },
    onScaleGroup({ events }) {
      events.forEach((ev) => {
        this.onScale(ev)
      })
    },
    onShiftChange(e) {
      // Mantem proporcao ao escalar enquanto Shift estiver pressionado.
      this.keepRatio = e.shiftKey
    },
    onRotate({ target, drag }) {
      target.style.transform = drag.transform
    },
    onDragGroup({ events }) {
      // Trava de eixo no grupo: decide UM eixo para todos (o deslocamento e
      // comum a todos os alvos), com base no delta do primeiro alvo.
      let lockAxis = null
      if (this.keepRatio && events.length) {
        const first = events[0]
        const id = first.target.id.split('-')[1]
        const start = this.dragStartPosMap[id]
        if (start) {
          const [x, y] = first.beforeTranslate
          lockAxis = Math.abs(x - start.x) >= Math.abs(y - start.y) ? 'y' : 'x'
        }
      }

      events.forEach((ev) => {
        const id = ev.target.id.split('-')[1]
        this.onDrag(ev, lockAxis, this.dragStartPosMap[id])
      })
    },
    onResizeGroup({ events }) {
      events.forEach((ev) => {
        ev.target.style.width = `${ev.width}px`
        ev.target.style.height = `${ev.height}px`
        ev.target.style.transform = ev.drag.transform
      })
    },
    onRotateGroup({ events }) {
      events.forEach((env) => {
        env.target.style.transform = env.drag.transform
      })
    },
  },
}
</script>

<style lang="scss">
// O canvas fica NO FLUXO (relative) para rolar junto com o conteudo — sair do
// fluxo (absolute) desincroniza o scroll do shell e quebra deseleção/retangulo
// de selecao. A paridade de posicao com a main (componentes ancorados em
// md-app 0,0) e obtida zerando os dois offsets que deslocavam o canvas: o
// padding do .md-app-content (abaixo) e o bloco seletor, que sai do fluxo.
.view-canvas {
  position: relative;
  min-height: calc(100vh - 120px);
}

// Seletor de dashboard (Voltar + lista), so no modo show. Fica como overlay
// (fora do fluxo) para NAO empurrar o canvas para baixo — no master ele tambem
// sobrepunha o topo, com os componentes ancorados atras. z-index acima dos
// componentes (ate ~40) e abaixo do menu/slider (10000+).
.dashboard-selector {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 900;
  display: flex;
  align-items: center;
}

// So no modo edicao: evita selecao de texto ao desenhar o retangulo de selecao.
.view-canvas.no-select {
  user-select: none;
}

.selection-box {
  position: fixed;
  z-index: 998;
  pointer-events: none;
  background: rgba(33, 150, 243, 0.15);
  border: 1px solid rgba(33, 150, 243, 0.8);
}

.componente {
  position: absolute;
}

// Canos: o wrapper (retangulo da bbox) nao intercepta o ponteiro, para que a
// area clicavel de selecao seja a propria linha do cano (as hit-lines dentro do
// SVG reativam pointer-events: stroke), e nao todo o retangulo da alca.
.componente-pipe {
  pointer-events: none;
}

// Botoes de acao (deletar/editar/resetar) na lateral direita do componente.
// Overlay posicionado via JS (left/top inline) fora do elemento escalado, por
// isso nao herda o transform: scale do componente.
.component-actions {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  // Acima do portal de edicao do cano (PipeOverlayPortal, 9990) e dos demais
  // componentes, abaixo do menu lateral (10000), para os botoes de acao ficarem
  // sempre clicaveis.
  z-index: 9995;

  // Zera as margens proprias do md-button para alinhar na mesma coluna.
  .md-button {
    margin: 0;
  }
}

.drag-zone {
  width: fit-content;
  height: fit-content;
}

.md-app-content {
  border-right: 0 !important;
}

// Zera o padding do content SO no host desta view (classe adicionada/removida
// em mounted/beforeDestroy). Com o canvas no fluxo, esse padding deslocava os
// componentes (~16px esq. / ~9px topo) da origem que a main usava (md-app 0,0).
// Escopado por classe para a regra nao-scoped nao vazar para as outras paginas.
.md-app-content.view-canvas-host {
  padding: 0 !important;
}
</style>
